import { useEffect } from 'react';

let stale = false;

export function useVersionCheck(pathname: string) {
  useEffect(() => {
    if (__APP_VERSION__ === 'dev') return;

    if (stale) {
      window.location.href = pathname;
      return;
    }

    fetch(`/version.json?t=${Date.now()}`)
      .then(r => r.json())
      .then(({ version }: { version: string }) => {
        if (version !== __APP_VERSION__) stale = true;
      })
      .catch(() => {});
  }, [pathname]);
}
